import styled, { css } from "styled-components";

export const HeaderNameContainer = styled.div``;

type SectionProps = {
  $isActive: boolean
}

export const Section = styled.div<SectionProps>`
  ${props=>!props.$isActive && css`
    opacity: 0.5;
    pointer-events: none;
  `}
  &:not(:last-child) {margin-bottom: 24px;}
`

export const SectionHead = styled.div`
  display: flex;
  gap: 4px;
  font-size: 18px;
  line-height: 1.2;
  &:not(:last-child) {margin-bottom: 10px;}
`

export const SectionIcon = styled.img`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
`

export const SectionBody = styled.img`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
`

export const ButtonWrapper = styled.div`
  margin-left: auto;
  width: 232px;
  flex: 0 0 232px;
`

export const Image = styled.img<{ height?: string }>`
	height: ${props => props.height || 'initial'};
`;